import { useEffect, useState } from "react";
import { useDataProvider, type Identifier } from "ra-core";
import { Progress } from "@/components/ui/progress";

import type { CampaignProgressSummary as ProgressType } from "../types";
import { getCampaignTaskTypeConfig } from "./campaignTaskTypes";

export const CampaignProgressByDefinition = ({
  campaignId,
  onSelectDefinition,
  selectedDefinitionId,
}: {
  campaignId: Identifier;
  onSelectDefinition?: (id: Identifier | null) => void;
  selectedDefinitionId?: Identifier | null;
}) => {
  const dataProvider = useDataProvider();
  const [progress, setProgress] = useState<ProgressType | null>(null);

  useEffect(() => {
    (dataProvider as any)
      .getCampaignProgress(campaignId)
      .then(setProgress)
      .catch(() => setProgress(null));
  }, [campaignId, dataProvider]);

  if (!progress?.by_definition?.length) return null;

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">By task definition</h3>
      {progress.by_definition.map((row) => {
        const pct = row.total > 0 ? Math.round((row.completed / row.total) * 100) : 0;
        const kindLabel =
          getCampaignTaskTypeConfig(row.kind as any)?.label ?? row.kind;
        const selected = selectedDefinitionId === row.definition_id;
        return (
          <button
            key={row.definition_id}
            type="button"
            className={`w-full text-left rounded-md border p-3 space-y-2 ${selected ? "border-primary bg-muted/50" : ""}`}
            onClick={() =>
              onSelectDefinition?.(
                selected ? null : row.definition_id,
              )
            }
          >
            <div className="flex justify-between text-sm">
              <span className="font-medium">{row.title}</span>
              <span className="text-muted-foreground">{kindLabel}</span>
            </div>
            <Progress value={pct} className="h-2" />
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>
                {row.completed}/{row.total} completed
              </span>
              {row.overdue > 0 && (
                <span className="text-destructive">{row.overdue} overdue</span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};
